module.exports = __webpack_public_path__ + "static/media/giorgio-armani-prive-ambre-orient-big.b22ec61c.png";